import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { CatalogForm } from '../../../../components/CatalogForm/CatalogForm';
import { Validators } from '../../../../components/CatalogForm/validators';
import Http from '../../../../Http';

export const PagoSucursal = ({ idCliente, sucursal, onSave, onCancel }) => {
  const [sucursales, setSucursales] = useState([]);

  useEffect(() => {
    let mounted = true;
    const fetchSucursales = async () => {
      try {
        const res = await Http.get('sucursal/all');
        if (mounted && res && !res.error && Array.isArray(res.data)) {
          setSucursales(
            res.data.map((s) => ({
              value: String(s.id),
              label: s.sucursal_nombre,
            }))
          );
        }
      } catch (err) {
        console.error('Error al cargar sucursales', err);
      }
    };
    fetchSucursales();
    return () => {
      mounted = false;
    };
  }, []);

  const initialValues = useMemo(
    () => ({
      id_sucursal: sucursal?.id_sucursal ? String(sucursal.id_sucursal) : '',
      porcentaje: sucursal?.porcentaje !== undefined && sucursal?.porcentaje !== null ? String(sucursal.porcentaje) : '0',
    }),
    [sucursal]
  );

  const fields = useMemo(
    () => [
      {
        name: 'id_sucursal',
        label: 'Sucursal',
        type: 'select',
        col: 6,
        required: true,
        validators: [Validators.required('La sucursal es requerida')],
        options: sucursales,
        placeholder: 'Seleccione sucursal',
      },
      {
        name: 'porcentaje',
        label: 'Porcentaje de Pago (%)',
        type: 'number',
        col: 6,
        required: true,
        validators: [Validators.required('El porcentaje es requerido')],
        placeholder: '0 - 100',
      },
    ],
    [sucursales]
  );

  const handleSubmit = useCallback(
    async (values) => {
      try {
        const payload = {
          ...values,
          id: sucursal?.id || null,
        };
        const res = await Http.post(`cliente/${idCliente}/pago-transportista/sucursal`, payload);
        return res;
      } catch (err) {
        return { error: true, errMsg: 'Error al guardar porcentaje de sucursal' };
      }
    },
    [idCliente, sucursal]
  );

  const handleSuccess = useCallback(() => {
    if (onSave) {
      onSave();
    }
  }, [onSave]);

  return (
    <div className="p-2">
      <CatalogForm
        title={sucursal?.id ? 'Editar Pago por Sucursal' : 'Asignar Pago por Sucursal'}
        subtitle="Defina el porcentaje aplicado al transportista por cada sucursal"
        fields={fields}
        initialValues={initialValues}
        onSubmit={handleSubmit}
        onSuccess={handleSuccess}
        onCancel={onCancel}
        submitButtonText="Guardar Sucursal"
      />
    </div>
  );
};

export default PagoSucursal;
